import React, { forwardRef } from 'react';
import { useHistory } from 'react-router-dom';
import './Navbar.css';
import { cosmosTrackService } from '../../../../../cosmosTracking/cosmosTrackService';
import {Milestone_page, Tools_page, Checklist_page, Overview_page} from '../../../../../cosmosTracking/cosmosEvents';

const Navbar = forwardRef((props, ref) => {
	const { data, activeTab, updateActiveTab, scrollNav, colorData } = props;
	const history = useHistory();

	return (
		<div className="page-navbar">
			<div className="navbar-inner" ref={ref}>
				{data?.map((item, i) => {
					const isActive = item?.key === activeTab?.key;
					return (
						<span className={'navbar-link ' + (isActive ? 'active' : '')} id={item?.key} key={item?.key} onClick={() => {

							if (item?.key === 'overview') {
								cosmosTrackService(Overview_page);
								scrollNav(1);
							}
							else if (item?.key === 'leaderboard') {
								scrollNav(-2);
							}
							else if (item?.key === 'milestones') {
								cosmosTrackService(Milestone_page);
								scrollNav(1);
							}
							else if (item?.key === 'tasks') {
								scrollNav(-2);
							}
							else if (item?.key === 'tools') {
								cosmosTrackService(Tools_page);
								scrollNav();
							}
							else if (item?.key === 'checklist') {
								cosmosTrackService(Checklist_page);
								scrollNav(2);
							}
							// else if (item?.key === 'leaderboard') {
							// 	scrollNav(-2);
							// }else if (item?.key === 'tasks') {
							// 	scrollNav(-2);
							// }else if (item?.key === 'redeem') {
							// 	scrollNav(-2);
							// }
							history.replace({ pathname: '/tutor/details/' + item?.key });
							updateActiveTab(item);
						}}>
							{item?.name}
						</span>
					);
				})}
			</div>
		</div>
	);
});

export default Navbar;
